export default __webpack_public_path__ + "static/media/phone_icon.3dab873b.svg";